import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "./de-CH.json";
import fr from "./fr-CH.json";
import it from "./IT-CH.json";

const resources = {
  "de-CH": {
    translation: de,
  },
  "fr-CH": {
    translation: fr,
  },
  "it-CH": {
    translation: it,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de-CH",
  fallbackLng: "de-CH",
  debug: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
